/* @flow */
import * as React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { Router, browserHistory } from 'react-router';
import { IntlProvider } from 'react-intl';
import { UserAgentProvider, windowStr } from 'lib/currentUserAgent';
import { CookiesProvider } from 'react-cookie';

import { createReduxStore } from '../reduxStore';

import routes from 'messages/router';

const Root = ({ apolloClient }: { apolloClient: * }) => {
  const reduxStore = createReduxStore();

  return (
    <IntlProvider locale="en">
      <Provider store={reduxStore}>
        <ApolloProvider store={reduxStore} client={apolloClient}>
          <UserAgentProvider userAgentSpec={windowStr}>
            <CookiesProvider>
              <Router history={browserHistory}>{routes}</Router>
            </CookiesProvider>
          </UserAgentProvider>
        </ApolloProvider>
      </Provider>
    </IntlProvider>
  );
};

export default Root;
